var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      staticStyle: { "z-index": "1000000" },
      attrs: {
        id: "resumeCategoryModal",
        "data-focus": "false",
        "data-keyboard": "false",
        "data-backdrop": "static",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
        _c("div", { staticClass: "modal-content" }, [
          _vm._m(0),
          _c("div", { staticClass: "modal-body" }, [
            _c(
              "div",
              { staticClass: "form-group form-inline" },
              [
                _c("label", { attrs: { for: "" } }, [
                  _vm._v("經驗分類-主分類"),
                ]),
                _c("multiselect", {
                  attrs: {
                    options: _vm.resumeTagOptions,
                    "close-on-select": false,
                    tagPlaceholder: "",
                    selectLabel: "",
                    selectedLabel: "",
                    deselectLabel: "",
                    label: "Name",
                    "track-by": "Guid",
                    placeholder: "請選擇",
                  },
                  model: {
                    value: _vm.person.MainResumeTag,
                    callback: function ($$v) {
                      _vm.$set(_vm.person, "MainResumeTag", $$v)
                    },
                    expression: "person.MainResumeTag",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-group form-inline" },
              [
                _c("label", { attrs: { for: "" } }, [
                  _vm._v("經驗分類-次分類"),
                ]),
                _c("multiselect", {
                  attrs: {
                    options: _vm.resumeTagOptions,
                    "close-on-select": false,
                    multiple: "",
                    tagPlaceholder: "",
                    selectLabel: "",
                    selectedLabel: "",
                    deselectLabel: "",
                    label: "Name",
                    "track-by": "Guid",
                    placeholder: "請選擇",
                  },
                  model: {
                    value: _vm.person.ResumeTags,
                    callback: function ($$v) {
                      _vm.$set(_vm.person, "ResumeTags", $$v)
                    },
                    expression: "person.ResumeTags",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-group form-inline" },
              [
                _vm._m(1),
                _c("multiselect", {
                  attrs: {
                    options: _vm.freeTagOptions,
                    taggable: true,
                    "close-on-select": false,
                    multiple: "",
                    tagPlaceholder: "",
                    selectLabel: "",
                    selectedLabel: "",
                    deselectLabel: "",
                    label: "Name",
                    "track-by": "Guid",
                    placeholder: "請選擇或自行新增",
                  },
                  on: { tag: _vm.addTag },
                  model: {
                    value: _vm.person.ResumeFreeTags,
                    callback: function ($$v) {
                      _vm.$set(_vm.person, "ResumeFreeTags", $$v)
                    },
                    expression: "person.ResumeFreeTags",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-group form-inline" },
              [
                _c("label", { attrs: { for: "" } }, [_vm._v("後續聯絡")]),
                _c("multiselect", {
                  attrs: {
                    options: ["可再約", "永不聯絡"],
                    placeholder: "請選擇",
                  },
                  model: {
                    value: _vm.person.ResumeContactRemark,
                    callback: function ($$v) {
                      _vm.$set(_vm.person, "ResumeContactRemark", $$v)
                    },
                    expression: "person.ResumeContactRemark",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-group form-inline" },
              [
                _c("label", { attrs: { for: "" } }, [_vm._v("備註")]),
                _c("el-input", {
                  staticClass: "w-100",
                  attrs: {
                    type: "textarea",
                    rows: 8,
                    maxlength: "400",
                    "show-word-limit": "",
                  },
                  model: {
                    value: _vm.person.Remark,
                    callback: function ($$v) {
                      _vm.$set(_vm.person, "Remark", $$v)
                    },
                    expression: "person.Remark",
                  },
                }),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.closeModal },
              },
              [_vm._v(" 關閉 ")]
            ),
            _vm.fromPage !== "歷史人才查詢"
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button" },
                    on: { click: _vm.putResumeTag },
                  },
                  [_vm._v(" 儲存 ")]
                )
              : _vm._e(),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("履歷分類")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "" } }, [
      _vm._v(" 其他分類"),
      _c("span", { staticClass: "mark" }, [
        _vm._v("（新增字數不可超過20個字）"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }